(function ($) {

    $(document).on( 'click', '#menu-toggler', function() {

        if($(this).hasClass('open')){
            $(this).removeClass('open');
            $('html').removeClass('noscroll');
            $('#primary-nav').removeClass('visible');
        } else {
            $(this).addClass('open');
            $('html').addClass('noscroll');
            $('#primary-nav').addClass('visible');
        }

    });

    $(document).on( 'click', '.menu-item-has-children', function(event) {

        if($(this).hasClass('open')){
            //$('.menu-item-has-children').removeClass('open');
            $(this).removeClass('open');
        } else {
            $('.menu-item-has-children').removeClass('open');
            $(this).addClass('open');
        }

    });

	$(document).on( 'click', '.smx-menu-search a', function(event) {

		$('#modal-search-wrapper').addClass('open');

    });

	$(document).on( 'click', '#modal-search-wrapper .modal-exit', function(event) {

		$('#modal-search-wrapper').removeClass('open');

    });


})
(jQuery);